/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Drop_Zone_ChangeInputs */

const en_new_project_drop_zone_change = /** @type {(inputs: New_Project_Drop_Zone_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click to choose a different file`)
};

const fr_new_project_drop_zone_change = /** @type {(inputs: New_Project_Drop_Zone_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez pour choisir un autre fichier`)
};

const de_new_project_drop_zone_change = /** @type {(inputs: New_Project_Drop_Zone_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicken Sie hier, um eine andere Datei auszuwählen.`)
};

const it_new_project_drop_zone_change = /** @type {(inputs: New_Project_Drop_Zone_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai clic per scegliere un file diverso`)
};

const ru_new_project_drop_zone_change = /** @type {(inputs: New_Project_Drop_Zone_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нажмите, чтобы выбрать другой файл`)
};

const es_new_project_drop_zone_change = /** @type {(inputs: New_Project_Drop_Zone_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz clic para elegir un archivo diferente.`)
};

const zh_cn2_new_project_drop_zone_change = /** @type {(inputs: New_Project_Drop_Zone_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击选择其他文件`)
};

const ja_new_project_drop_zone_change = /** @type {(inputs: New_Project_Drop_Zone_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`別のファイルを選択するにはクリックしてください`)
};

const hi_new_project_drop_zone_change = /** @type {(inputs: New_Project_Drop_Zone_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई दूसरी फ़ाइल चुनने के लिए क्लिक करें`)
};

const pt_pt2_new_project_drop_zone_change = /** @type {(inputs: New_Project_Drop_Zone_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique para escolher um arquivo diferente.`)
};

/**
* | output |
* | --- |
* | "Click to choose a different file" |
*
* @param {New_Project_Drop_Zone_ChangeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_drop_zone_change = /** @type {((inputs?: New_Project_Drop_Zone_ChangeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Drop_Zone_ChangeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_drop_zone_change(inputs)
	if (locale === "de") return de_new_project_drop_zone_change(inputs)
	if (locale === "it") return it_new_project_drop_zone_change(inputs)
	if (locale === "ru") return ru_new_project_drop_zone_change(inputs)
	if (locale === "es") return es_new_project_drop_zone_change(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_drop_zone_change(inputs)
	if (locale === "ja") return ja_new_project_drop_zone_change(inputs)
	if (locale === "hi") return hi_new_project_drop_zone_change(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_drop_zone_change(inputs)
	return en_new_project_drop_zone_change(inputs)
});